import { SignIn } from "@clerk/clerk-react";
import { CLERK_OIDC_PROMPT } from '../auth/appSession';
import AuthBrandPanel from './AuthBrandPanel';

function RightPanel() {
  return (
    <div className="w-full md:w-1/2 flex items-center justify-center px-4 bg-white">
      {/* Hide only Clerk branding, not the sign-in link */}
      <style>{`
        .cl-internal-footer-powered-by,
        .cl-internal-tk30ch, /* 'Secured by' text */
        .cl-internal-1scq7x4, /* Clerk logo link */
        .cl-internal-5ghyhf /* Clerk logo SVG */
        { display: none !important; }

        /* Clerk renders its sign-in form inside a card with a default outline. */
        .cl-card,
        .cl-cardBox {
          border: none !important;
          box-shadow: none !important;
        }

        .cl-footer,
        .cl-footerAction {
          background: transparent !important;
          box-shadow: none !important;
        }
      `}</style>
      <div className="w-full max-w-md">
        <SignIn
          routing="path"
          path="/sign-in"
          oidcPrompt={CLERK_OIDC_PROMPT}
          fallbackRedirectUrl="/after-sign-in"
          forceRedirectUrl="/after-sign-in"
          signUpUrl="/sign-up"
          appearance={{
            elements: {
              logoBox: { display: "none" },
              rootBox: { width: "100%" },
              cardBox: {
                width: "100%",
                border: "none",
                boxShadow: "none",
              },
              card: {
                width: "100%",
                border: "none",
                boxShadow: "none",
                padding: "2rem",
              },
              headerTitle: { fontSize: "1.75rem" },
              headerSubtitle: { fontSize: "1rem" },
              formFieldLabel: { fontSize: "0.95rem" },
              formFieldInput: { minHeight: "3rem", fontSize: "1rem" },
              formButtonPrimary: { minHeight: "3rem", fontSize: "1rem" },
              socialButtonsBlockButton: { minHeight: "3rem", fontSize: "1rem" },
              footer: { background: "transparent", boxShadow: "none" },
              footerAction: { background: "transparent" },
            },
            variables: {
              colorPrimary: "#274D3B",
            },
          }}
        />
        <p className="px-8 pb-6 text-center text-xs leading-5 text-gray-500">
          By continuing you agree to our{' '}
          <a
            href="https://www.marstrix.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-[#274D3B] underline underline-offset-2"
          >
            terms
          </a>{' '}
          and{' '}
          <a
            href="https://www.marstrix.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-[#274D3B] underline underline-offset-2"
          >
            privacy
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default function SignInPage() {
  return (
    <div className="min-h-screen w-full flex flex-col md:flex-row bg-white">
      <AuthBrandPanel />
      <RightPanel />
    </div>
  );
}
